import { Row, Col, Card } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { BaseUseCase } from 'services/apps/usecases';
import styles from './styles.module.css';

type UseCasesProps = {
  usecases: BaseUseCase[];
  onSelectedUseCase?: (useCase?: BaseUseCase) => void;
  selectedUseCase?: BaseUseCase;
};
const UseCases = ({ usecases }: UseCasesProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <Row justify="center" gutter={[32, 32]} style={{ marginBottom: 48, marginTop: 48 }}>
      {usecases.map((matchingUseCase: BaseUseCase) => (
        <Col key={matchingUseCase.id} xs={24} md={12} lg={8}>
          <Card
            style={{ minHeight: '120px' }}
            // hoverable={!!onSelectedUseCase}
            // onClick={
            //   onSelectedUseCase
            //     ? () => {
            //         matchingUseCase.id === selectedUseCase?.id
            //           ? onSelectedUseCase(undefined)
            //           : onSelectedUseCase(matchingUseCase);
            //       }
            //     : undefined
            // }
            className={classNames(styles.selected)}
          >
            <h3>{formatMessage(matchingUseCase.title)}</h3>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
export default UseCases;
